export const SET_FIELD = 'DPT_BINDERY/SET_FIELD';
export const FETCH_DATA = 'DPT_BINDERY/FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'DPT_BINDERY/FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'DPT_BINDERY/FETCH_DATA_ERROR';
export const SAVE = 'DPT_BINDERY/SAVE';
export const SAVE_SUCCESS = 'DPT_BINDERY/SAVE_SUCCESS';
export const SAVE_ERROR = 'DPT_BINDERY/SAVE_ERROR';
export const FETCH_ELEMENT = 'DPT_BINDERY/FETCH_ELEMENT';
export const FETCH_ELEMENT_SUCCESS = 'DPT_BINDERY/FETCH_ELEMENT_SUCCESS';
export const FETCH_ELEMENT_ERROR = 'DPT_BINDERY/FETCH_ELEMENT_ERROR';
export const SET_ACTIVE_PAGE = 'DPT_BINDERY/SET_ACTIVE_PAGE';
export const RESET_FORM = 'DPT_BINDERY/RESET_FORM';